module.exports = [
  {
    id: 1,
    img: "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=800&q=80",
    title: "10 European ski destinations you should visit this winter",
    date: "Jan 06, 2023",
    delayAnimation: "100",
    details: `For decades, travelers have been escaping to the Catskills — a mountainous region in upstate New York — whenever they’ve needed a reset.`,
    tag: "art",
    tags: ["adventure_travel", "food_drink"],
  },
  {
    id: 2,
    img: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80",
    title: "Booking travel during Corona: good advice in an uncertain time",
    date: "April 06, 2022",
    delayAnimation: "200",
    details: `For decades, travelers have been escaping to the Catskills — a mountainous region in upstate New York — whenever they’ve needed a reset.`,
    tag: "beaches",
    tags: ["beaches", "family_holidays"],
  },
  {
    id: 3,
    img: "https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=800&q=80",
    title: "Where can I go? 5 amazing countries that open right now",
    date: "Jan 06, 2023",
    delayAnimation: "300",
    details: `For decades, travelers have been escaping to the Catskills — a mountainous region in upstate New York — whenever they’ve needed a reset.`,
    tag: "adventure",
    tags: ["art_culture", "food_drink"],
  },
  {
    id: 4,
    img: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80",
    title: "10 European ski destinations you should visit this winter",
    date: "April 06, 2022",
    delayAnimation: "400",
    details: `For decades, travelers have been escaping to the Catskills — a mountainous region in upstate New York — whenever they’ve needed a reset.`,
    tag: "explore",
    tags: ["beaches", "family_holidays"],
  },
  {
    id: 5,
    img: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80",
    title: "Booking travel during Corona: good advice in an uncertain time",
    date: "Jan 06, 2023",
    delayAnimation: "100",
    details: `For decades, travelers have been escaping to the Catskills — a mountainous region in upstate New York — whenever they’ve needed a reset.`,
    tag: "holidays",
    tags: ["art_culture", "food_drink"],
  },
  {
    id: 6,
    img: "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=800&q=80",
    title: "Where can I go? 5 amazing countries that are open right now",
    date: "April 06, 2022",
    delayAnimation: "200",
    details: `For decades, travelers have been escaping to the Catskills — a mountainous region in upstate New York — whenever they’ve needed a reset.`,
    tag: "travel",
    tags: ["beaches", "family_holidays"],
  },
  {
    id: 7,
    img: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80",
    title: "10 European ski destinations you should visit this winter",
    date: "Jan 06, 2023",
    delayAnimation: "300",
    details: `For decades, travelers have been escaping to the Catskills — a mountainous region in upstate New York — whenever they’ve needed a reset.`,
    tag: "food",
    tags: ["art_culture", "food_drink"],
  },
  {
    id: 8,
    img: "https://images.unsplash.com/photo-1499678329028-101435549a4e?w=800&q=80",
    title: "Booking travel during Corona: good advice in an uncertain time",
    date: "April 06, 2022",
    delayAnimation: "200",
    details: `For decades, travelers have been escaping to the Catskills — a mountainous region in upstate New York — whenever they’ve needed a reset.`,
    tag: "holidays",
    tags: ["art_culture", "food_drink"],
  },
  {
    id: 9,
    img: "https://images.unsplash.com/photo-1586348943529-beaae6c28db9?w=800&q=80",
    title: "Where can I go? 5 amazing countries that are open right now",
    date: "April 06, 2022",
    delayAnimation: "300",
    details: `For decades, travelers have been escaping to the Catskills — a mountainous region in upstate New York — whenever they’ve needed a reset.`,
    tag: "park",
    tags: ["beaches", "explore"],
  },
  {
    id: 10,
    img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&q=80",
    title: "10 European ski destinations you should visit this winter",
    date: "April 06, 2022",
    delayAnimation: "100",
    details: `Ut enim ad minim veniam, quis nostrud exerc ullamco laboris nisi ut aliquip.`,
    tag: "",
    tags: ["art_culture", "food_drink"],
  },
  {
    id: 11,
    img: "https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=800&q=80",
    title: "Where can I go? 5 amazing countries that are open right now",
    date: "April 06, 2022",
    delayAnimation: "200",
    details: `Ut enim ad minim veniam, quis nostrud exerc ullamco laboris nisi ut aliquip.`,
    tag: "",
    tags: ["art_culture", "air_travel"],
  },
];
